<faa-header></faa-header>
<div>
    <router-outlet></router-outlet>
</div>
<!-- <faa-footer></faa-footer> -->